// todo this file is not used for production
// move order from vue to vuex


import shop from '../../api/dashboard'

// initial state
const state = () => ({
  items: [],
  status: null,
  curbsidePickupOrder: null
})

// getters
const getters = {
  orderItems: (state, getters, rootState) => {
    return state.items.map(({ id, quantity }) => {
      const product = rootState.products.all.find(product => product.id === id)
      return {
        title: product.title,
        price: product.price,
        quantity
      }
    })
  },

  cartTotalPrice: (state, getters) => {
    return getters.cartProducts.reduce((total, product) => {
      return total + product.price * product.quantity
    }, 0)
  },

  curbsidePickupOrder: (state) => state.curbsidePickupOrder
}

// actions
const actions = {
  pay ({ commit, state }, products) {
    const savedCartItems = [...state.items]
    commit('setStatus', null)
    // empty cart
    commit('setItems', { items: [] })
    shop.buyProducts(
      products,
      () => commit('setStatus', 'closed'),
      () => {
        commit('setStatus', 'failed')
        // rollback to the cart saved before sending the request
        commit('setCartItems', { items: savedCartItems })
      }
    )
  },

  addProductToCart ({ state, commit }, product) {
    commit('setCheckoutStatus', null)
    if (product.inventory > 0) {
      const cartItem = state.items.find(item => item.id === product.id)
      if (!cartItem) {
        commit('pushProductToCart', { id: product.id })
      } else {
        commit('incrementItemQuantity', cartItem)
      }
      // remove 1 item from stock
      commit('products/decrementProductInventory', { id: product.id }, { root: true })
    }
  },

  setCurbsidePickupOrder ({ commit }, data) {
    commit('setCurbsidePickupOrder', data)
  }
}

// mutations
const mutations = {
  pushProductToCart (state, { id }) {
    state.items.push({
      id,
      quantity: 1
    })
  },

  incrementItemQuantity (state, { id }) {
    const cartItem = state.items.find(item => item.id === id)
    cartItem.quantity++
  },

  setOrderItems (state, { items }) {
    state.items = items
  },

  setStatus (state, status) {
    state.status = status
  },

  setCurbsidePickupOrder (state, data) {
    state.curbsidePickupOrder = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
